import { createAsyncThunk } from '@reduxjs/toolkit'
import { QUERY_GET_BY_CALL_ID, QUERY_GET_ISCASEBLOCKEDBYUSER, QUERY_PUT_BLOCKCASE, QUERY_PUT_UPDATECASELIST,QUERY_PUT_SETNOTMANAGED,QUERY_PUT_ISCASEWITHOUTPLATE, QUERY_PUT_ISCASEWITHOUTCNPJ} from '../../fetch/constantQueries'
import { fetchGet,fetchPagination, fetchPut} from '../../fetch/fetchConfig'
import { QUERY_GET_CASES,QUEY_GET_MASTER_COUNT} from '../../fetch/constantQueries'
import { getContractByCaseId } from '../contract/thunks'
import { errorHandler } from '../../commonFunctions/errorHandler'
import { openModal } from '../modal/modalSlice'
import { baseThunk, getUrl } from '../../fetch/basicThunk'

export const postCaseList = baseThunk("cases/postCaseList", QUERY_GET_CASES, "GET")
export const postCaseCount = baseThunk("cases/count",QUEY_GET_MASTER_COUNT,"GET");

export const updateCaseList = createAsyncThunk (
  'cases/updateCaseList',
    async (params, thunkApi) => {
      try{
          const response = await fetch( getUrl() + QUERY_PUT_UPDATECASELIST, fetchPut(params));
          if (!response.ok){
            let message = await JSON.parse(await response.text());
            const error = {code: response.status, message: message};
            throw error;};

          let caseLoaded= undefined;
          const currentCase = thunkApi.getState().contract.contract.case;
          if(currentCase){
            if (Array.isArray(params.ids)){
              caseLoaded = params.ids.find((e)=> e === currentCase.caseId )
            }
          
          if (caseLoaded){
            await thunkApi.dispatch(getContractByCaseId({query: "?caseId="+ caseLoaded}))}
          }
          const data = response.json()
    return data
        } catch(error){
          thunkApi.dispatch(openModal(errorHandler(error)))
          throw error
        }
    }
)

export const isCaseBlockedByUser = baseThunk("cases/checkBlock", QUERY_GET_ISCASEBLOCKEDBYUSER, "GET");

export const getCaseByCallId = createAsyncThunk(
  'cases/case',
  async (callId, thunkApi) => {
        const response = await fetch( getUrl() + QUERY_GET_BY_CALL_ID + `?callId=${callId}`, fetchGet());
        if (!response.ok){
          const error = {code: response.status, message: await response.json()} 
          throw error};
        const data = response.json()
  return data;
  }
)

export const markCaseWithoutPlate = baseThunk('cases/markCaseWithoutPlate', QUERY_PUT_ISCASEWITHOUTPLATE, "PUT")
export const markCaseWithoutCNPJ = baseThunk('cases/markCaseWithoutCNPJ', QUERY_PUT_ISCASEWITHOUTCNPJ, "PUT")

export const setNotManaged = createAsyncThunk (
  'cases/setNotManaged',
    async (params, thunkApi) => {
      try{
          const response = await fetch( getUrl() + QUERY_PUT_SETNOTMANAGED, fetchPut(params));
          
          if (!response.ok){
            let message = await JSON.parse(await response.text());
            const error = {code: response.status, message: message};
            throw error;};

          let caseLoaded= undefined;
          const currentCase = thunkApi.getState().contract.contract.case;
          if(currentCase){
            if (Array.isArray(params.ids)){
              caseLoaded = params.ids.find((e)=> e === currentCase.caseId )
            }
          
          if (caseLoaded){
            await thunkApi.dispatch(getContractByCaseId({query: "?caseId="+ caseLoaded}))}
          }
          const data = response.json()
    return data
        } catch(error){
          thunkApi.dispatch(openModal(errorHandler(error)))
          throw error
        }
    }
)

